var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},_vm._l((_vm.reports),function(report){return _c('ReportCard',{key:report.profile_id,attrs:{"report":report}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }